import LinkManagement from "./link-management.page";

export default LinkManagement;
